import script from "./CitationChips.vue?vue&type=script&setup=true&lang=js"
export * from "./CitationChips.vue?vue&type=script&setup=true&lang=js"

import "./CitationChips.vue?vue&type=style&index=0&id=2d36daf8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d36daf8"]])

export default __exports__